import { observer } from "mobx-react-lite";
import styled from "styled-components";
import {
  faCircleX as errorIcon,
  faExclamationCircle as infoIcon,
  faExclamationTriangle as warningIcon,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { SectionHeader } from "@pages/editor/components/SectionHeader";
import { SectionList } from "@pages/editor/components/SectionList";
import { ErrorResult } from "@pages/editor/stores";
import { RuleValidationError } from "@pages/editor/types";

const ErrorBox = styled.div`
  white-space: pre-wrap;
  display: grid;
  align-items: center;
  grid-template-columns: 24px 1fr;
  column-gap: var(--global-spacing-xs);
`;

interface ErrorProps {
  error: RuleValidationError;
}

const ErrorElement = ({ error }: ErrorProps) => {
  return (
    <ErrorBox>
      <FontAwesomeIcon
        icon={
          error.severity === "Error"
            ? errorIcon
            : error.severity === "Warning"
            ? warningIcon
            : infoIcon
        }
        style={{
          fontSize: "16px",
          alignSelf: "start",
          marginTop: "2px",
          color: `var(--global-${
            error.severity === "Error"
              ? "red"
              : error.severity === "Warning"
              ? "yellow"
              : "blue"
          })`,
        }}
      />
      <span style={{ fontSize: "13px" }}>
        <code>{error.message}</code>
        <code
          style={{
            marginLeft: "var(--global-spacing-s)",
            color: "var(--gray2)",
          }}
        >
          {error.source}({error.code})
        </code>
        <code
          style={{
            color: "var(--gray2)",
            fontSize: "13px",
            marginLeft: "var(--global-spacing-s)",
          }}
        >
          {error.startPos
            ? `[Ln ${error.startPos?.lineno ?? 0}, Col ${
                error.startPos?.col ?? 0
              }]`
            : ""}
        </code>
      </span>
    </ErrorBox>
  );
};

interface ErrorsSectionProps {
  result: ErrorResult;
}

const Section = ({ result }: ErrorsSectionProps) => {
  return (
    <>
      <SectionHeader>Errors</SectionHeader>
      <SectionList style={{ padding: "var(--global-spacing-m)" }}>
        {result.errors.map((error, index) => (
          <ErrorElement error={error} key={index} />
        ))}
      </SectionList>
    </>
  );
};

export const ErrorsSection = observer(Section);
